import React from "react";
import { InventoryStatus } from "src/pages/inventory/center/components/InventoryStatus";
import { Layout, LegacyCard } from "@shopify/polaris";
import { useTranslation } from "react-i18next";

export function InventorySummary() {
  const { t } = useTranslation();
  return (
    <Layout.Section variant="oneHalf">
      <LegacyCard
        title={t("page_dashboard.inventory_summary")}
        actions={[{ content: t("general.more_detail"), url: "/inventory/center", external: true }]}
      >
        <InventoryStatus
          display={[
            {
              value: "Unpaid fees",
              link: "/dashboard/fbl/volumn",
            },
            {
              value: "Inventory status",
              link: "/dashboard/fbl",
            },
          ]}
        />
      </LegacyCard>
    </Layout.Section>
  );
}
